import React from 'react';
import { Button } from '../ui/button';
import { Phone, ExternalLink } from 'lucide-react';
import { openWhatsApp } from './constants';

export const CtaSection = () => (
  <section className="py-20 bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-500 relative overflow-hidden" data-testid="cta-section">
    <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-white/3 to-white/5 opacity-20"></div>
    <div className="container mx-auto px-4 relative z-10 text-center">
      <h3 className="text-4xl md:text-5xl font-bold text-white mb-6">¿Listo para el futuro?</h3>
      <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">Únete a miles de usuarios que ya disfrutan de seguros inteligentes</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
          size="lg"
          data-testid="cta-whatsapp-btn"
          className="bg-white text-blue-600 hover:bg-white/90 shadow-xl rounded-full px-8 py-6 text-lg font-bold transform hover:scale-105 transition-all duration-300"
          onClick={openWhatsApp}
        >
          <Phone className="h-5 w-5 mr-2" />
          Hablar con un experto
        </Button>
        <Button
          size="lg"
          variant="outline"
          data-testid="cta-quote-btn"
          className="border-2 border-white/30 text-white hover:bg-white/10 backdrop-blur-md rounded-full px-8 py-6 text-lg font-bold"
          onClick={() => window.open('https://forms.gle/uYUQZBZMWvpvjk7F9', '_blank')}
        >
          <ExternalLink className="h-5 w-5 mr-2" />
          Cotizar online
        </Button>
      </div>
    </div>
  </section>
);

export default CtaSection;
